import { QueryLayoutProps } from 'modules/queryBuilder/contexts';
import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import {
  ActionButtonWrapper,
  MainWrapper,
  CombinatorWrapper,
  TextWrapper,
  Toolbar,
  Combinator,
} from './QueryLayout.styles';

const testIds = {
  criteriaGroup: 'qb-criteria-group',
  queryGroup: 'qb-query-group',
};

export const QueryLayout = ({
  Add,
  AITools,
  CombinatorSelect,
  Criteria,
  EditReadSelect,
  UndoButton,
  RedoButton,
}: QueryLayoutProps) => {
  const { t } = useTranslation();
  return (
    <MainWrapper>
      {CombinatorSelect && (
        <CombinatorWrapper data-test={testIds.queryGroup}>
          <Combinator>
            <TextWrapper>{t('storybook.layouts.query.preText')}</TextWrapper>
            {CombinatorSelect}
            <TextWrapper>{t('storybook.layouts.query.postText')}</TextWrapper>
          </Combinator>
          <ActionButtonWrapper>
            {UndoButton}
            {RedoButton}
            {EditReadSelect}
            {AITools && <Toolbar>{AITools}</Toolbar>}
          </ActionButtonWrapper>
        </CombinatorWrapper>
      )}
      {Criteria.map((SingleCriteria, i) => (
        <div key={`criteria-${i}`} data-test={testIds.criteriaGroup}>
          {SingleCriteria}
        </div>
      ))}
      {Add}
    </MainWrapper>
  );
};
